import request from "@/config/utils/request";
//应用设置：设置分类和等级接口状态查询
export function queryBaseData(data) {
  return request({
    url: "/apis/demo/activate/applyActivate/queryBaseData",
    method: "post",
    data
  });
}

//应用设置：设置分类和等级接口
export function setBaseData(data) {
  return request({
    url: "/apis/demo/activate/applyActivate/setBaseData",
    method: "post",
    data
  });
}
